
export default "/assets/stop-micro.0abe2bdd.svg"